import { Thumbmark } from '@thumbmarkjs/thumbmarkjs';

export const initTmAnalytics = async (store) => {
  try {
    const tm = new Thumbmark({ logging: false });
    const { thumbmark } = await tm.get();
    const value = thumbmark ? `v2:${thumbmark}` : '';

    window.AffCtrlUserId = value;
    store.$api.affiliates.defaults.headers.common['X-User-Id'] = value;
    store.$api.misc.defaults.headers.common['X-User-Id'] = value;
  } catch (e) {
    console.error(e);
  }
};
